"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authPrizeContract = void 0;
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const utils_1 = require("../utils");
const models_1 = require("./models");
const c = (0, core_1.initContract)();
const ZGetFavouritedPrizesResponse = models_1.ZPrizeCore.extend({
    categories: zod_1.z.string().array(),
    tierCode: zod_1.z.string(),
    tierValue: zod_1.z.number().nullable(),
    drawTypePlans: zod_1.z.string().array(),
}).array();
exports.authPrizeContract = c.router({
    getFavouritedPrizes: {
        method: 'GET',
        path: '/get-favourited-prizes',
        query: zod_1.z.object({
            drawSchedule: zod_1.z.string(),
        }),
        responses: {
            200: ZGetFavouritedPrizesResponse,
            404: zod_1.z.object({
                message: zod_1.z.string(),
            }),
        },
        summary: 'Get favourite prizes (wish list) of a player',
    },
    getFavouritedPrizeIds: {
        method: 'GET',
        path: '/get-favourited-prize-ids',
        responses: {
            200: zod_1.z.number().array(),
            404: zod_1.z.object({
                message: zod_1.z.string(),
            }),
        },
        summary: 'Get ids of favourite prizes (wish list) of a player',
    },
    favouritePrize: {
        method: 'POST',
        path: '/favourite-prize',
        body: zod_1.z.object({
            prizeId: zod_1.z.coerce.number(),
        }),
        responses: {
            200: utils_1.successSchema,
        },
        summary: 'Favourite a prize',
    },
    unfavouritePrize: {
        method: 'DELETE',
        path: '/favourite-prize',
        body: zod_1.z.object({
            prizeId: zod_1.z.coerce.number(),
        }),
        responses: {
            200: utils_1.successSchema,
        },
        summary: 'Unfavourite a prize',
    },
}, {
    pathPrefix: '/auth',
    baseHeaders: zod_1.z.object({
        'x-access-token': zod_1.z.string(),
    }),
    commonResponses: {
        401: c.type(),
    },
});
//# sourceMappingURL=prize.auth.contract.js.map